import axiosClient from '../axiosClient';
import { APP_API_URL ,MAPPING_API_URL,DEVELOPER_API_URL,APP_TOKEN,DEV_SUB, DEVELOPERAPP_API_URL} from '../constants';

const ApplicationServices = {
  fetchApplications: async (
    page: any,
    rowsPerPage: any,
    domainName: string,
    organizationName: string,
    applicationType: string,
    applicationName: string,
    applicationId?: string
  ) => {
    const response = await axiosClient.get(`${APP_API_URL}`, {
      params: {
        domainName: domainName ? domainName : '3Insys',
        pageNumber: page,
        pageSize: rowsPerPage,
        organizationName,
        applicationType: applicationType || 'A,C,S,W',
        applicationName,
        applicationId
      }
    });
    return response.data;
  },
  createApplication: async (body: any) => {
    try {
      const response = await axiosClient.post(`${APP_API_URL}`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  deleteApplication: async (data: any) => {
    try {
      const response = await axiosClient.delete(`${APP_API_URL}`, {
        params: {
          domainId: data?.domainId,
          orgId: data?.orgId,
          applicationId: data.applicationId,
          applicationType: data.applicationType
        }
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  updateApplication: async (body: any, userId: 'string') => {
    try {
      const response = await axiosClient.put(`${APP_API_URL}/${userId}`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  mappingApplication: async (body: any) => {
    try {
      const response = await axiosClient.post(`${MAPPING_API_URL}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  getClientId: async (data: any) => {
    try {
      const response = await axiosClient.get(`${DEVELOPERAPP_API_URL}/applications/oauth-keys`, {
        params: {
          domainName: data.domainName,
          organizationName: data.organizationName,
          applicationId: data.applicationId,
          applicationType: data.applicationType
        }
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  getToken: async (data: any) => {
    try {
      const response = await axiosClient.post(`${APP_TOKEN}`, {
        dom_name: data.dom_name,
        org_name: data.org_name,
        client_id: data.client_id,
        client_secret: data.client_secret
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  downloadApplications: async () => {
    try {
      const response = await axiosClient.get(`${APP_API_URL}/download`);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  getApis: async ({ domainName, organizationName, applicationName, applicationType, apiStatus, pageSize, pageNumber }: any) => {
    try {
      const response = await axiosClient.get(`${DEVELOPER_API_URL}`, {
        params: {
          domainName,
          organizationName,
          applicationType,
          applicationName,
          apiStatus,
          pageSize,
          pageNumber: pageNumber + 1
        }
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  subscriptionApi: async (body: any, action: 'string') => {
    try {
      const response = await axiosClient.post(`${DEV_SUB}/${action}`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }
};

export default ApplicationServices;
